import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_methods: {
    delivery: 'Consegna',
    pickup: 'Ritiro',
    room_service: 'In loco',
    table_service: 'In loco',
  },
  asap: 'Prima possibile',
  unavailable: 'Non disponibile',
  ready_in_time: 'Pronto in {{time}} min',
  locations: {
    [ORDER_METHODS.DELIVERY]: 'Consegna a {{address}}',
    [ORDER_METHODS.PICKUP]: 'Ritiro presso {{address}}',
    [ORDER_METHODS.ROOM_SERVICE]: 'In loco presso {{address}}',
  },
  buttons: {
    change: 'Modifica',
    see_hours: 'Vedi orari',
    change_location: 'Cambia posizione',
    change_time: 'Cambia orario',
  },
};
